import { logger } from "@utilities/logger";

export async function hashEmail(email: string) {
  try {
    const normalized = email.toLowerCase().trim();
    const encoded = new TextEncoder().encode(normalized);
    const hashBuffer = await crypto.subtle.digest("SHA-256", encoded);
    return Array.from(new Uint8Array(hashBuffer))
      .map(b => b.toString(16).padStart(2, "0"))
      .join("");
  } catch (error) {
    logger.error(error instanceof Error ? error : null, "[hashEmail] Failed to hash email");
    return undefined;
  }
}
